import { render, staticRenderFns } from "./TurnoverUser.vue?vue&type=template&id=9ab4faa8&"
import script from "./TurnoverUser.vue?vue&type=script&lang=js&"
export * from "./TurnoverUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports